const Button = {
    baseStyle: {
        fontFamily: 'Lato',
        fontWeight: 'none'
    }
};

export default Button;
